// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__BydGh","title":"Header_title__3ythJ","side":"Header_side__AL0Tg"};